import React, { useState } from "react"
import { Row, Col } from "reactstrap"

import Image1 from "../../../images/aboutus/Pre build solutions.png"
import Image2 from "../../../images/aboutus/Collaboration.png"

import Constants from "../../../constants/aboutUs.json"

const SideImageContent = props => {
  return (
    <div className="side-image-content">
      <h2 className="top-description">{Constants.topDescription}</h2>
      <div className="image-container">
        <Row>
          <Col sm="6" xs="12" className="image">
            <img
              src={Image1}
              alt="Auto Scale Jitsi Meet, Jigasi, Jicofo, Jibri and Prosody on AWS"
            />
          </Col>
          <Col sm="6" xs="12" className="text">
            <div className="title large-font">
              {Constants.SideByContent.item1.title}
            </div>
            <div className="description medium-font">
              {Constants.SideByContent.item1.description}
            </div>
          </Col>
        </Row>
        <Row className="bottom-row">
          <Col sm="6" xs="12" className="text">
            <div className="title large-font">
              {Constants.SideByContent.item2.title}
            </div>
            <div className="description medium-font">
              {Constants.SideByContent.item2.description}
            </div>
          </Col>
          <Col sm="6" xs="12" className="image">
            <img
              src={Image2}
              alt="Go Big with Jitsi Meet. Contact Meetrix.IO now"
            />
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default SideImageContent
